import React, { useEffect, useMemo, useState } from 'react';
import {
  GridView,
  CompositeView,
  SimpleView,
  useRouter,
  MasterDetailForm,
  FormInput,
  FormDatePicker,
  ColumnProps,
  Button,
  Widget,
  FormSelect,
  FormSubmitButton,
  FormatText,
} from '@digital/ui';
import { Collapse, Row, Col, Table, Tooltip } from 'antd';
import {
  getDadosProposta,
  SasProposta,
  updatePropostaResultado,
  SasAnexoProposta,
  downloadSasAnexoPropostabyId,
  viweSasAnexoProposta,
  createSasProposta,
  SasPropostaForm,
  SasFornecedor,
} from '@app/api/sas/sasProposta';
import './custom.css';
import { convertUTCtoLocal } from '@app/helpers/dateTimeFormats';
import moment from 'moment';
import { hasPermission, hasPermissionPerfil } from '@app/helpers/permissions';
import ModalExcluirVendor from './ModalExcluirVendor';
import { EGuidPerfilAcesso } from '@app/enums/EGuidPerfilAcesso';
import { getStatusOrdem } from '@app/api/status';
import { EStatusOrdemCompra } from '@app/enums/EStatusOrdemCompra';

const { Panel } = Collapse;

const Proposta = () => {
  var { match } = useRouter();
  const [id, setId] = useState(match.params.id);
  const [proposta, setProposta] = useState<SasProposta>();
  const [update, setUpdate] = useState(false);
  const [statusCodigo, setStatusCodigo] = useState(0);

  const onSasPropostaUpdate = () => {
    setUpdate(!update);
  };

  const getStatusOrder = (ordemId: string) => {
    getStatusOrdem(ordemId).then(resp => {
      if (resp) {
        setStatusCodigo(resp.codigo);
      }
    });
  };

  const resultadoAvaliacaoPropostaTecnicaOptions = () => {
    return new Promise<any>((resolve, reject) => {
      resolve([
        { text: 'Aprovado', value: 'Aprovado' },
        { text: 'Reprovado', value: 'Reprovado' },
        { text: 'Declinio', value: 'Declinio' },
        { text: 'Em Revisão', value: 'Em Revisão' },
      ]);
    });
  };

  const resultadoAvaliacaoOptions = () => {
    return new Promise<any>((resolve, reject) => {
      resolve([
        { text: 'Aprovado', value: 'Aprovado' },
        { text: 'Reprovado', value: 'Reprovado' },
        { text: 'Em Revisão', value: 'Em Revisão' },
      ]);
    });
  };

  const onSubmitPropostaTecnica = (e: any) => {
    if (proposta) {
      updatePropostaResultado({
        sasPropostaId: proposta.id || '',
        resultadoAvaliacao: e.resultadoAvaliacaoTecnica,
        comentarioAvaliacao: e.comentarioAvaliacaoTecnica,
        propostaTecnica: true,
      }).then((data: any) => {
        onSasPropostaUpdate();
      });
    }
  };

  const onSubmitPropostaComercial = (e: any) => {
    if (proposta) {
      updatePropostaResultado({
        sasPropostaId: proposta.id || '',
        resultadoAvaliacao: e.resultadoAvaliacaoComercial,
        comentarioAvaliacao: e.comentarioAvaliacaoComercial,
        propostaComercial: true,
      }).then((data: any) => {
        onSasPropostaUpdate();
      });
    }
  };

  const onSubmitDadosFornecedor = (values: SasFornecedor) => {
    var submit: SasPropostaForm = {
      ordemCompraId: proposta.ordemCompraId,
      codigoTotvs: values.codigoTotvs,
      cnpj: values.cnpj,
      razaoSocial: values.razaoSocial,
      email: values.email,
      statusSasPropostaId: values.statusSasProposta,
      nomeContato: values.nome,
      telefoneContato: values.telefone1
    };

    createSasProposta(submit).then(data => {
      if (data.valid) {
        onSasPropostaUpdate();
      }
    });
  };

  useEffect(() => {
    if (id) {
      getDadosProposta(id).then(data => {
        if (data) {
          setProposta(data);
          getStatusOrder(data.ordemCompraId);
        }
      });
    }
  }, [id, update]);

  const downloadTudoAnexosPropostaTecnica = (arquivos: SasAnexoProposta[]) => {
    arquivos.forEach(element => {
      downloadSasAnexoPropostabyId(element.id, element.nome);
    });
  };

  const columnsAnexos = useMemo(() => {
    const columns: ColumnProps<any>[] = ([] = new Array());

    columns.push({
      title: 'nome',
      dataIndex: 'nome',
    });

    columns.push({
      title: 'inclusão',
      dataIndex: 'dataInclusao',
      width: '10%',
      render: (text, record) => convertUTCtoLocal(moment(record.dataInclusao)).toLocaleString(),
    });

    columns.push({
      title: 'ações',
      dataIndex: 'acoes',
      width: '10%',
      render: (text, record) => {
        return (
          <>
            <Tooltip title="Baixar Arquivo">
              <Button
                icon="ui-download"
                onClick={async () => {
                  await downloadSasAnexoPropostabyId(record.id, record.nome);
                }}
                icon="ui-download"
              />
            </Tooltip>
            {record.nome.slice(-3).toLowerCase() === 'pdf' && (
              <Tooltip title="Visualizar Arquivo">
                <Button
                  onClick={async () => {
                    await viweSasAnexoProposta(record.id, record.nome);
                  }}
                  icon="files-view_file"
                  name="btnVisualizarArquivo"
                />
              </Tooltip>
            )}
          </>
        );
      },
    });

    return columns;
  }, [proposta]);

  return (
    <SimpleView>
      <CompositeView>
        {proposta && (
          <GridView noform>
            <Collapse bordered={false} defaultActiveKey="fornecedor">
              <Panel key="fornecedor" header="Vendor List">
                <MasterDetailForm initialValues={proposta.sasFornecedor} onSubmit={onSubmitDadosFornecedor}>
                  <Widget
                    actions={[
                      hasPermission(['SAS_ALTERAR_DADOS_FORNECEDOR']) && (
                        <FormSubmitButton noIcon={true} type="primary">
                          <FormatText id="ui.commons.save" uppercase />
                        </FormSubmitButton>
                      ),
                      hasPermission(['SAS_ALTERAR_DADOS_FORNECEDOR']) && (
                        <ModalExcluirVendor id={proposta.id} idOrdemCompra={proposta.ordemCompraId} />
                      ),
                    ]
                    }>
                    <Row>
                      <FormInput
                        label="Nome Fornecedor"
                        name="nome"
                        span={8}
                        disabled={!hasPermission(['SAS_ALTERAR_DADOS_FORNECEDOR'])}
                      />
                      <FormInput
                        label="CNPJ"
                        name="cnpj"
                        span={2}
                        disabled={!hasPermission(['SAS_ALTERAR_DADOS_FORNECEDOR'])}
                      />
                      <FormInput
                        label="Código Totvs"
                        name="codigoTotvs"
                        span={2}
                        disabled={!hasPermission(['SAS_ALTERAR_DADOS_FORNECEDOR'])}
                      />
                    </Row>
                    <Row>
                      <FormInput
                        label="Telefone Fornecedor"
                        name="telefone1"
                        span={4}
                        disabled={!hasPermission(['SAS_ALTERAR_DADOS_FORNECEDOR'])}
                      />
                      <FormInput
                        label="Razão Social"
                        name="razaoSocial"
                        span={8}
                        disabled={!hasPermission(['SAS_ALTERAR_DADOS_FORNECEDOR'])}
                      />
                    </Row>
                    <Row>
                      <FormInput label="Status desta Cotação" name="statusSasProposta" span={4} disabled={true} />
                      <FormInput label="Email Fornecedor" name="email" span={8} disabled />
                    </Row>
                  </Widget>
                </MasterDetailForm>
              </Panel>
            </Collapse>

            <Collapse bordered={false} defaultActiveKey="cartaConvite">
              <Panel key="cartaConvite" header="Carta Convite">
                <MasterDetailForm initialValues={proposta}>
                  <Row>
                    <FormDatePicker
                      format="DD/MM/YYYY"
                      label="Envio Carta Convite"
                      name="dataEnvioCartaConvite"
                      placeholder=""
                      span={4}
                      disabled
                    />
                    <FormInput
                      label="Status Carta Convite"
                      name="statusCartaConvite"
                      span={4}
                      disabled
                      placeholder="Carta Convite ainda não enviada."
                    />
                    <FormDatePicker
                      format="DD/MM/YYYY"
                      label="Data Aceite"
                      name="dataAceiteCartaConvite"
                      placeholder=""
                      span={4}
                      disabled
                    />
                  </Row>
                </MasterDetailForm>
              </Panel>
            </Collapse>

            {hasPermission(['SAS_VISUALIZAR_PROPOSTA_TECNICA']) && (
              <Collapse bordered={false} defaultActiveKey="propostaTecnica">
                <Panel key="propostaTecnica" header="Proposta Técnica">
                  <MasterDetailForm initialValues={proposta} onSubmit={onSubmitPropostaTecnica}>
                    <Widget
                      actions={[
                        hasPermission(['SAS_ALTERAR_PROPOSTA_TECNICA']) && (
                          <FormSubmitButton noIcon={true} type="primary">
                            <FormatText id="ui.commons.save" uppercase />
                          </FormSubmitButton>
                        ),
                      ]}>
                      <Row className="col-no-padding" gutter={16}>
                        <Col span={8} className="gutter-row">
                          <FormDatePicker
                            format="DD/MM/YYYY"
                            label="Solicitação da Proposta Técnica"
                            name="dataEnvioPropostaTecnica"
                            placeholder="00/00/0000"
                            span={12}
                            disabled
                          />
                        </Col>
                        <Col span={16} className="gutter-row">
                          <Table dataSource={proposta.anexosPropostaTecnica} columns={columnsAnexos} rowKey="id" />
                          <Button
                            style={{ float: 'right' }}
                            onClick={() => downloadTudoAnexosPropostaTecnica(proposta.anexosPropostaTecnica)}>
                            Baixar Tudo
                          </Button>
                        </Col>
                      </Row>
                      <Row>
                        <FormSelect
                          getOptions={resultadoAvaliacaoPropostaTecnicaOptions}
                          name="resultadoAvaliacaoTecnica"
                          label="Resultado Avaliação Técnica"
                          span={3}
                          disabled={
                            (hasPermissionPerfil([EGuidPerfilAcesso.GestorTecnico]) && statusCodigo != EStatusOrdemCompra.AguardandoAnaliseTecnica) ||
                            !hasPermission(['SAS_ALTERAR_PROPOSTA_TECNICA'])
                          }
                        />
                        <FormInput label="Gestor Técnico" name="nomeGestorTecnico" span={6} disabled />
                        <FormDatePicker
                          format="DD/MM/YYYY"
                          placeholder="00/00/0000"
                          label="Data Avaliação Técnica"
                          name="dataAvaliacaoTecnica"
                          span={3}
                          disabled
                        />
                      </Row>
                      <Row>
                        <FormInput
                          name="comentarioAvaliacaoTecnica"
                          label="Comentários Avaliação Técnica"
                          disabled={
                            !hasPermission(['SAS_ALTERAR_PROPOSTA_TECNICA']) ||
                            !proposta.dataEnvioPropostaTecnica
                          }
                          span={12}
                        />
                      </Row>
                    </Widget>
                  </MasterDetailForm>
                </Panel>
              </Collapse>
            )}
            {hasPermission(['SAS_VISUALIZAR_PROPOSTA_COMERCIAL']) && (
              <Collapse bordered={false} defaultActiveKey="propostaComercial">
                <Panel key="propostaComercial" header="Proposta Comercial">
                  <MasterDetailForm initialValues={proposta} onSubmit={onSubmitPropostaComercial}>
                    <Widget
                      actions={[
                        hasPermission(['SAS_ALTERAR_PROPOSTA_COMERCIAL']) && (
                          <FormSubmitButton noIcon={true} type="primary">
                            <FormatText id="ui.commons.save" uppercase />
                          </FormSubmitButton>
                        ),
                      ]}>
                      <Row className="col-no-padding" gutter={16}>
                        <Col className="gutter-row" span={8}>
                          <FormDatePicker
                            format="DD/MM/YYYY"
                            placeholder="00/00/0000"
                            label="Solicitação Proposta Comercial"
                            name="dataEnvioPropostaComercial"
                            span={12}
                            disabled
                          />
                          <FormInput
                            name="valorPropostaComercial"
                            label="Valor Proposta Comercial"
                            disabled
                            span={12}
                          />
                        </Col>
                        <Col span={16} className="gutter-row">
                          <Table dataSource={proposta.anexosPropostaComercial} columns={columnsAnexos} rowKey="id" />
                          <Button
                            style={{ float: 'right' }}
                            onClick={() => downloadTudoAnexosPropostaTecnica(proposta.anexosPropostaComercial)}>
                            Baixar Tudo
                          </Button>
                        </Col>
                      </Row>
                      <Row>
                        <FormSelect
                          name="resultadoAvaliacaoComercial"
                          label="Resultado Avaliação Comercial"
                          getOptions={resultadoAvaliacaoOptions}
                          span={3}
                          disabled={
                            !hasPermission(['SAS_ALTERAR_PROPOSTA_COMERCIAL']) ||
                            !proposta.dataEnvioPropostaComercial
                          }
                        />
                        <FormInput label="Comprador" name="compradorNome" span={6} disabled />
                        <FormDatePicker
                          format="DD/MM/YYYY"
                          label="Data Avaliação Comercial"
                          name="dataAvaliacaoComercial"
                          placeholder=""
                          span={3}
                          disabled
                        />
                      </Row>
                      <Row>
                        <FormInput
                          name="comentarioAvaliacaoComercial"
                          label="Comentários Avaliação Comercial"
                          disabled={
                            !hasPermission(['SAS_ALTERAR_PROPOSTA_COMERCIAL']) ||
                            !proposta.dataEnvioPropostaComercial
                          }
                          span={12}
                        />
                      </Row>
                    </Widget>
                  </MasterDetailForm>
                </Panel>
              </Collapse>
            )}
          </GridView>
        )}
      </CompositeView>
    </SimpleView>
  );
};
export default Proposta;
